import api from "../../api"
import { formatDate, getVisibility } from "../../utils"
import dayjs from 'dayjs'
import eventAdapter from '../event/adapter'
import blogAdapter from '../blog/adapter'
import resourceAdapter from '../resource/adapter'
import { collectionSubAdapter } from "../collection/adapter"
import { fieldData, fields } from "../program-form-v1/components/sections/related/constants"
import systemAdapter from '../system/adapter'

export const subAdapter = {
  journey: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          pkJourneyId,
          nomorUrut,
          judulJourney,
          deskripsi,
          imgThumbnailJourney,
        } = input

        output = {
          id: pkJourneyId,
          pkId: pkJourneyId,
          title_en: judulJourney[1],
          title_id: judulJourney[0],
          title: {
            en: judulJourney[1],
            id: judulJourney[0]
          },
          index: nomorUrut,
          descrpition_en: deskripsi[1],
          description_id: deskripsi[0],
          description: {
            en: deskripsi[1],
            id: deskripsi[0]
          },
          thumbnail: api.base_image+imgThumbnailJourney,
          image: api.base_image+imgThumbnailJourney,
        }
      }

      return output
    }
  },
  partner: {
    internal: {
      responseBodyToRender(input = []){
        let output = []

        if(input && input.length > 0){
          for (let index = 0; index < input.length; index++) {
            const element = input[index];
            const {pkPartnerActivityInternalId, partner} = element
            output.push({
              pkId: pkPartnerActivityInternalId,
              id: partner.organisasiId,
              name: partner.namaOrganisasi,
              image: api.base_image+partner.imgLogoOrganisasi
            })
          }
        }

        return output
      }
    },
    external: {
      responseBodyToRender(input = []){
        let output = []

        if(input && input.length > 0){
          for (let index = 0; index < input.length; index++) {
            const element = input[index];
            const {
              pkPartnerActivityEksternalId,
              namaPartner,
              websitePartner,
              imgLogoPartner,
            } = element
            output.push({
              pkId: pkPartnerActivityEksternalId,
              id: pkPartnerActivityEksternalId,
              name: namaPartner,
              website: websitePartner,
              image: api.base_image+imgLogoPartner
            })
          }
        }

        return output
      }
    }
  },
  officer: {
    responseBodyToRender(input = []){
      let output = []

        if(input && input.length > 0){
          for (let index = 0; index < input.length; index++) {
            const element = input[index];
            const {userId, namaIndividu, imgFotoProfile} = element

            output.push({
              fromResponseBody: true,
              id: userId,
              name: namaIndividu,
              image: api.base_image+imgFotoProfile
            })
          }
        }

        return output
    }
  },
  location: {
    responseBodyToRender(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];

          output.push({
            id: element.pkLokasiActivityId,
            province: element.provinsi,
            city: element.kota,
            address: element.jalan
          })
        }
      }

      return output
    }
  },
  milestone: {
    responseBodyToRender(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];

          const {
            faseId,
            nomorUrut,
            // resources,
            binFaseFile,
            isDone,
            // systemRowId,
            deskripsi,
          } = element

          const splited = binFaseFile.split('/')
          const filename = splited[splited.length-1]

          const adaptedFiles = binFaseFile === '/assets/file.pdf' ? [] : [{
            name: filename,
            file: api.base_image+binFaseFile
          }]

          output[nomorUrut] = {
            id: faseId,
            index: nomorUrut,
            file: api.base_image+binFaseFile,
            description: {
              en: deskripsi[1],
              id: deskripsi[0]
            },
            isDone,

            // table data
            description_en: deskripsi[1],
            description_id: deskripsi[0],
            status: isDone === false ? 'incompleted' : 'completed',
            files: adaptedFiles
          }
        }
      }

      return output
    }
  },
  city: {
    responseBodyToRender(input = []){
      let result = ''

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];
          const { kota } = element
          result += index < input.length-1 ? `${kota}, ` : kota
        }
      } else {
        result = '-'
      }

      return result
    }
  },
  impact: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          pkBaselineEndlineSurveyId,
          variablePerubahan,
          pretest,
          posttest
        } = input

        output = {
          id: pkBaselineEndlineSurveyId,
          name: variablePerubahan?.nama?.[0],
          categoryId: variablePerubahan?.id,
          category: variablePerubahan?.kategori?.[0],
          baseline: pretest,
          endline: posttest
        }
      }

      return output
    },
    responseBodyToByCategory(input = []){
      const output = {}

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];
          const { variablePerubahan } = element
          if(variablePerubahan && variablePerubahan.kategori && variablePerubahan.kategori[0]){
            const category = variablePerubahan.kategori[0]
            if(!output[category]){
              output[category] = [subAdapter.impact.responseBodyToRender(element)]
            } else {
              output[category].push(subAdapter.impact.responseBodyToRender(element))
            }
          }
        }
      }

      return output
    },
    responseBodyToHighestValue(input = []){
      let output = 0

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          if(input[index].pretest > output){
            output = input[index].pretest
          }

          if(input[index].posttest > output){
            output = input[index].posttest
          }
        }
      }

      return output
    }
  },
  testimonial: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          pkTestimoniUserId,
          deskripsi,
          userId
        } = input
        output = {
          id: pkTestimoniUserId,
          text: deskripsi,
          name: userId?.namaIndividu,
          image: userId && userId.imgFotoProfile ? api.base_image+userId.imgFotoProfile : undefined
        }
      }

      return output
    }
  },
  testimonial_external: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          pkTestimoniNonUserId,
          deskripsi,
          nama,
          imgFoto
        } = input
        output = {
          id: pkTestimoniNonUserId,
          text: deskripsi,
          name: nama,
          image: api.base_image+imgFoto
        }
      }

      return output
    }
  },
  comment: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          commentId,
          deskripsiComment,
          tanggalJam,
          userId
        } = input

        output = {
          id: commentId,
          text: deskripsiComment,
          user: {
            id: userId?.userId,
            name: userId?.namaIndividu,
            image: userId && userId.imgFotoProfile ? api.base_image+userId.imgFotoProfile : undefined,
          },
          _date: tanggalJam,
          // renderable date
          date: dayjs(tanggalJam).format('MMMM DD, YYYY [at] HH:mm a'),
          date_by_language: {
            en: dayjs(tanggalJam).format('MMMM DD, YYYY [at] HH:mm a'),
            id: dayjs(tanggalJam).locale('id').format('DD MMMM YYYY [pukul] HH:mm')
          },
        }
      }

      return output
    }
  },
  visibility: {
    responseBodyToForm(key, value){
      return {
        label: key,
        name: key,
        visibility: {
          public: false,
          user: false,
          verified_user: false,
          organization: false,
          my_organization: false
        }
      }
    }
  },
}

const adapter = {
  responseBodyToRender(responseBody){
    let result = {}

    if(responseBody){
      const {
        activityId = '',
        programId,
        imgThumbnail = '',
        imgMainImage = '',
        tanggalMulai = '',
        tanggalSelesai = '',
        myOrganisasi = {},
        judulActivity = ['', ''],
        deskripsiPanjang = ['', ''],
        deskripsiPendek = ['', ''],
        lokasi = [],
        journey = [],
        activityResult = {},
        storyOfChange = [],
        galleries= [],
        typeAudience = [],
        typeApproach = [],
        typeIssues = [],
        partnerActivityInternal = [],
        partnerActivityEksternal = [],
        officer = [],
        fase,
        files = [],
        createdAt,
        totalLikes,
        totalBookmarks,
        testimoniUser = [],
        testimoniNonUser = [],
        submission,
        comments,
        events = [],
        blogs = [],
        resources = [],
        statusActivity,
        tag = [],
        cancelReason,
        listLike = [],
        listBookmark = [],
        catatanModerasi,
        likedByMe,
        bookmarkByMe
      } = responseBody

      const organization = myOrganisasi ? myOrganisasi : {}
      const {
        beneficiariesMen = 0,
        beneficiariesWomen = 0,
        beneficiariesMenDifable = 0,
        beneficiariesWomenDifable = 0,
        baselineEndlineSurvey = 0,
        retentionSaatProgramMen = 0,
        retentionSaatProgramWomen = 0,
        retentionPascaProgramMen = 0,
        retentionPascaProgramWomen = 0,
        satisfactionSangatTidakPuas = 0,
        satisfactionTidakPuas = 0,
        satisfactionNetral = 0,
        satisfactionPuas = 0,
        satisfactionSangatPuas = 0,
        netPromotorScoreDetractors = 0,
        netPromotorScorePassive = 0,
        netPromotorScorePromoters = 0,
        netPromotorScore1 = 0,
        netPromotorScore2 = 0,
        netPromotorScore3 = 0,
        netPromotorScore4 = 0,
        netPromotorScore5 = 0,
        netPromotorScore6 = 0,
        netPromotorScore7 = 0,
        netPromotorScore8 = 0,
        netPromotorScore9 = 0,
        netPromotorScore10 = 0,
        customerAcquisitionScore = 0,
      } = activityResult

      const retention_is_empty =
        retentionSaatProgramMen === 0
        && retentionSaatProgramWomen === 0
        && retentionPascaProgramMen === 0
        && retentionPascaProgramWomen === 0

      const retention_highest_value = Math.max(retentionSaatProgramMen, retentionSaatProgramWomen, retentionPascaProgramMen, retentionPascaProgramWomen)

      const satisfaction_is_empty =
        satisfactionSangatPuas === 0
        && satisfactionPuas === 0
        && satisfactionNetral === 0
        && satisfactionTidakPuas === 0
        && satisfactionSangatTidakPuas === 0

      const nps_is_empty =
        // netPromotorScoreDetractors === 0
        // && netPromotorScorePassive === 0
        // && netPromotorScorePromoters === 0
        netPromotorScore1 === 0
        && netPromotorScore2 === 0
        && netPromotorScore3 === 0
        && netPromotorScore4 === 0
        && netPromotorScore5 === 0
        && netPromotorScore6 === 0
        && netPromotorScore7 === 0
        && netPromotorScore8 === 0
        && netPromotorScore9 === 0
        && netPromotorScore10 === 0

      const visibility_field_blacklist = [
        'vsbDeskripsiPendek',
        'vsbDeskripsiPanjang',
        'vsbTanggalMulai',
        'vsbTanggalSelesai',
        'vsbTypeSensitivity',
        'vsbTypeVisibility',
        'vsbTbCoOwner',
        'vsbTbLokasiOnline',
        'vsbTbPartnerActivityInternal',
        'vsbTbPartnerActivityEksternal',
        'vsbTbFiles',
        'vsbTbGalleries',
        'vsbEvents',
        'vsbResources',
        'vsbBlogs',
        'vsbSubProgram',
        'vsbPrecedingProgram',
        'vsbTag',
      ]

      const visibility = getVisibility(responseBody).visibility
      const visibility_id_only = getVisibility(responseBody, visibility_field_blacklist).visibilityIdOnly
      const visibility_keys = getVisibility(responseBody).visibilityKeys
      const visibility_settings = visibility_keys?.map(v => subAdapter.visibility.responseBodyToForm(v, visibility[v]))
      const is_all_public = getVisibility(responseBody).isAllPublic
      const is_private = getVisibility(responseBody).isPrivate

      const beneficiaries_total = beneficiariesMen + beneficiariesWomen + beneficiariesMenDifable + beneficiariesWomenDifable

      const is_upcoming = dayjs().isBefore(tanggalMulai)
      const is_ongoing = dayjs().isAfter(new Date(tanggalMulai)) && dayjs().isBefore(new Date(tanggalSelesai))
      const is_past = dayjs().isAfter(new Date(tanggalSelesai))

      const start_datetime = systemAdapter.date_time.responseBodyToRender(tanggalMulai, 'en')
      const end_datetime = systemAdapter.date_time.responseBodyToRender(tanggalSelesai, 'en')
      const start_datetime_id = systemAdapter.date_time.responseBodyToRender(tanggalMulai, 'id')
      const end_datetime_id = systemAdapter.date_time.responseBodyToRender(tanggalSelesai, 'id')

      const satisfaction_total =
        satisfactionSangatPuas
        + satisfactionPuas
        + satisfactionNetral
        + satisfactionTidakPuas
        + satisfactionSangatTidakPuas

      const nps_total_detractor = netPromotorScore1+netPromotorScore2+netPromotorScore3+netPromotorScore4+netPromotorScore5+netPromotorScore6
      const nps_total_passive = netPromotorScore7+netPromotorScore8
      const nps_total_promotor = netPromotorScore9+netPromotorScore10
      const nps_total = nps_total_detractor+nps_total_passive+nps_total_promotor
      const nps_promotor = nps_total_promotor/nps_total*100
      const nps_detractor = nps_total_detractor/nps_total*100
      const nps = nps_promotor-nps_detractor

      result = {
        id: programId ? programId : (activityId ? activityId : undefined),
        is_all_public,
        is_private,
        created_at: createdAt,
        thumbnail: api.base_image + imgThumbnail,
        image: api.base_image + imgMainImage,
        date_start: tanggalMulai,
        date_end: tanggalSelesai,
        date: `${dayjs(new Date(tanggalMulai)).format('DD MMM, YYYY')} - ${dayjs(new Date(tanggalSelesai)).format('DD MMM, YYYY')}`,
        start_end_datetime_pdf: {
          en: `${start_datetime} –\n${end_datetime}`,
          id: `${start_datetime_id} –\n${end_datetime_id}`,
        },
        organization_id: organization.organisasiId,
        organization: organization.namaOrganisasi,
        organization_logo: api.base_image+organization.imgLogoOrganisasi,
        is_ongoing,
        is_past,
        is_upcoming,
        title: {
          en: judulActivity[1],
          id: judulActivity[0],
        },
        excerpt: {
          en: deskripsiPendek[1],
          id: deskripsiPendek[0],
        },
        content: {
          en: deskripsiPanjang[1],
          id: deskripsiPanjang[0]
        },
        featured: false,
        journeys: journey.map(j => subAdapter.journey.responseBodyToRender(j)),

        beneficiaries_total,
        beneficiaries_gender_men: beneficiariesMen,
        beneficiaries_gender_women: beneficiariesWomen,
        beneficiaries_gender_difable_men: beneficiariesMenDifable,
        beneficiaries_gender_difable_women: beneficiariesWomenDifable,

        retention_pre_program_men: retentionSaatProgramMen,
        retention_pre_program_women: retentionSaatProgramWomen,
        retention_post_program_men: retentionPascaProgramMen,
        retention_post_program_women: retentionPascaProgramWomen,
        retention_is_empty,
        retention_highest_value,

        satisfaction_total,
        satisfaction_very_satisfied: satisfactionSangatPuas,
        satisfaction_satisfied: satisfactionPuas,
        satisfaction_neutral: satisfactionNetral,
        satisfaction_disatisfied: satisfactionTidakPuas,
        satisfaction_very_disatisfied: satisfactionSangatTidakPuas,
        satisfaction_is_empty,

        nps_detractors: netPromotorScoreDetractors,
        nps_passives: netPromotorScorePassive,
        nps_promoters: netPromotorScorePromoters,

        nps_1: netPromotorScore1,
        nps_2: netPromotorScore2,
        nps_3: netPromotorScore3,
        nps_4: netPromotorScore4,
        nps_5: netPromotorScore5,
        nps_6: netPromotorScore6,
        nps_7: netPromotorScore7,
        nps_8: netPromotorScore8,
        nps_9: netPromotorScore9,
        nps_10: netPromotorScore10,
        nps_total_detractor,
        nps_total_passive,
        nps_total_promotor,
        nps_total,
        nps,

        nps_is_empty,

        cac: customerAcquisitionScore,

        impact_surveys: baselineEndlineSurvey && baselineEndlineSurvey.map(s => subAdapter.impact.responseBodyToRender(s)),
        impact_surveys_by_category: subAdapter.impact.responseBodyToByCategory(baselineEndlineSurvey),
        impact_surveys_highest_value: subAdapter.impact.responseBodyToHighestValue(baselineEndlineSurvey),

        stories: storyOfChange.map(story => {
          return {
            id: story.blogId,
            description: {
              en: story.deskripsiPendek[1],
              id: story.deskripsiPendek[0]
            }
          }
        }),

        gallery: {
          images: galleries.map(image => {
            return {
              pkId: image.pkGalleryId,
              url: api.base_image+image.imgGambar,
              description: {
                en: image.deskripsiGambar?.[1],
                id: image.deskripsiGambar?.[0]
              }
            }
          })
        },

        audiences: typeAudience.map(audience => {
          const {id, nama} = audience
          return {
            id,
            name: {
              en: nama[1],
              id: nama[0]
            }
          }
        }),
        audienceIds: typeAudience.map(audience => audience.id),
        approaches: typeApproach.map(approach => {
          const {id, nama} = approach
          return {
            id,
            name: {
              en: nama[1],
              id: nama[0]
            }
          }
        }),
        issues: typeIssues.map(issue => {
          const {id, nama} = issue
          return {
            id,
            name: {
              en: nama[1],
              id: nama[0]
            }
          }
        }),
        tags: tag.map(t => {
          const { pkTagId, pilihanTagId } = t
          const {id, nama} = pilihanTagId

          return {
            pkId: pkTagId,
            id,
            name: {
              en: nama[1],
              id: nama[0]
            }
          }
        }),
        approach_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeApproach),
        issue_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeIssues),
        audience_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeAudience),

        partners: [
          ...subAdapter.partner.internal.responseBodyToRender(partnerActivityInternal),
          ...subAdapter.partner.external.responseBodyToRender(partnerActivityEksternal)
        ],

        officers: subAdapter.officer.responseBodyToRender(officer),
        locations: subAdapter.location.responseBodyToRender(lokasi),
        milestones: subAdapter.milestone.responseBodyToRender(fase),

        files: files.map(file => {
          const splitted = file.binFile.split('/')
          return {
            ...file,
            id: file.pkFileId,
            link: api.base_image+file.binFile,
            description_id: file.deskripsiFile[0],
            description_en: file.deskripsiFile[1],
            name: splitted[splitted.length-1]
          }
        }),

        // DASHBOARD TABLE DATA
        date_table: `${dayjs(new Date(tanggalMulai)).format('DD/MM/YYYY')} - ${dayjs(new Date(tanggalSelesai)).format('DD/MM/YYYY')}`,
        status_id: statusActivity?.id,
        status: {
          en: is_upcoming ? 'upcoming' : is_ongoing ? 'ongoing' : is_past ? 'completed' : statusActivity?.nama[1],
          id: is_upcoming ? 'upcoming' : is_ongoing ? 'ongoing' : is_past ? 'completed' : statusActivity?.nama[0]
        },
        city: subAdapter.city.responseBodyToRender(lokasi),
        cities: lokasi.length,
        beneficiaries: beneficiaries_total,
        submission,

        // VISIBILITY
        visibility,
        visibility_id_only,
        visibility_keys,
        visibility_settings,

        // INTERACTION
        total_likes: totalLikes,
        total_bookmarks: totalBookmarks,
        testimonials: testimoniUser?.map(t => subAdapter.testimonial.responseBodyToRender(t)),
        testimonials_external: testimoniNonUser?.map(t => subAdapter.testimonial_external.responseBodyToRender(t)),
        comments: comments?.map(c => subAdapter.comment.responseBodyToRender(c)),

        // Related Collections
        events: events.map(e => eventAdapter.responseBodyToRender(e)),
        blogs: blogs.map(e => blogAdapter.responseBodyToRender(e)),
        resources: resources.map(e => resourceAdapter.responseBodyToRender(e)),

        reason: catatanModerasi,
        cancel_reason: cancelReason,
        likes: listLike.map(l => collectionSubAdapter.like.responseBodyToRender(l)),
        bookmarks: listBookmark.map(l => collectionSubAdapter.like.responseBodyToRender(l)),

        // Program Form v1 data
        related_collections: fields.map(field => {
          const obj = fieldData[field]
          return {
            field,
            label: obj.label,
            apiRoute: obj.apiRoute,
            items: responseBody[field]?.map(d => ({
              id: d[obj.idKey],
              title: d[obj.labelKey] ? {
                id: d[obj.labelKey][0],
                en: d[obj.labelKey][1]
              } : d[obj.idKey]
            }))
          }
        }),

        liked: likedByMe,
        bookmarked: bookmarkByMe
      };
    }

    return result
  },
  responseBodyToRenderBasic(input){
    let result = {}

    if(input){
      const {
        programId = '',
        imgThumbnail = '',
        tanggalMulai = '',
        tanggalSelesai = '',
        judulActivity = ['', ''],
        deskripsiPendek = ['', ''],
        typeApproach = [],
        typeIssues = [],
      } = input

      result = {
        id: programId,
        thumbnail: api.base_image + imgThumbnail,
        date: `${formatDate(tanggalMulai)} - ${formatDate(
          tanggalSelesai
        )}`,
        title: {
          en: judulActivity[1],
          id: judulActivity[0],
        },
        description: {
          en: deskripsiPendek[1],
          id: deskripsiPendek[0]
        },
        approach_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeApproach),
        issue_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeIssues),
      };
    }

    return result
  },
  responseBodyToOptions(input){
    let output = {}

    if(input){
      const {
        judulActivity,
        programId
      } = input

      output = {
        label: judulActivity?.[0],
        value: programId
      }
    }

    return output
  }
}

export default adapter
